export default __webpack_public_path__ + "static/media/role.358ec462.svg";